import {
  LayoutDashboard,
  Users,
  PhoneCall,
  MessagesSquare,
  Settings2,
  ListChecks,
  Tag,
  Contact,
  MessageCircle,
  Smartphone,
  UserCog,
  Cpu,
  Hash,
  Settings,
} from "lucide-react";

import Dashboard from "./Dashboard/Analytics";
import FBDashboard from "./PhoneBridge/dashboard";
import FBUsers from "./PhoneBridge/users";
import FBDevices from "./PhoneBridge/devices";
import FBPhoneNumbers from "./PhoneBridge/PhoneNumbers";
import Contacts from "./Contacts";
import Conversations from "./Conversations";
import ContactDetails from "./Contacts/DetailPage";
import CustomFields from "./CustomFields";
import CustomValues from "./CustomValues";
import Tags from "./Tags";
import Integrations from "./Integrations";
import { SocketProvider } from "context/socket";

export default function useRoutes() {
  return [
    {
      id: "dashboard",
      icon: <LayoutDashboard />,
      path: "/dashboard",
      title: "Dashboard",
      component: <Dashboard />,
    },
    {
      id: "contacts",
      icon: <Contact />,
      path: "/contacts",
      title: "Contacts",
      checkPermission: true,
      component: <Contacts />,
      subItems: [
        {
          parentId: "contacts",
          id: "contacts_detail",
          path: "/detail/:contactId",
          checkPermission: true,
          component: <ContactDetails />,
        },
      ],
    },
    {
      id: "conversations",
      icon: <MessageCircle />,
      path: "/conversations",
      title: "Conversations",
      checkPermission: true,
      component: (
        <SocketProvider>
          <Conversations />
        </SocketProvider>
      ),
    },
    {
      id: "phone_bridge",
      icon: <PhoneCall />,
      path: "/phone_bridge",
      title: "Phone Bridge",
      isCollapse: true,
      checkPermission: true,
      subItems: [
        {
          parentId: "phone_bridge",
          id: "dashboard",
          path: "/dashboard",
          title: "Dashboard",
          checkPermission: true,
          component: <FBDashboard />,
        },
        {
          parentId: "phone_bridge",
          id: "users",
          path: "/users",
          title: "Users",
          checkPermission: true,
          component: <FBUsers />,
        },
        {
          parentId: "phone_bridge",
          id: "devices",
          path: "/devices",
          title: "Devices",
          checkPermission: true,
          component: <FBDevices />,
        },
        {
          parentId: "phone_bridge",
          id: "phone-numbers",
          path: "/phone-numbers",
          title: "Phone Numbers",
          checkPermission: true,
          component: <FBPhoneNumbers />,
        },
      ],
    },
    {
      id: "integrations",
      icon: <LayoutDashboard />,
      path: "/integrations",
      title: "Integrations",
      component: <Integrations />,
    },
    {
      id: "settings",
      icon: <Settings />,
      path: "/settings",
      target: "/tags",
      title: "Settings",
      checkPermission: false,
      isIsolatedMenu: true,
      isBottomFixed: true,
      subItems: [
        {
          parentId: "settings",
          id: "custom_fields",
          icon: <Settings2 />,
          path: "/custom_fields",
          title: "Custom Fields",
          checkPermission: true,
          component: <CustomFields />,
        },
        {
          parentId: "settings",
          id: "custom_values",
          icon: <ListChecks />,
          path: "/custom_values",
          title: "Custom Values",
          checkPermission: true,
          component: <CustomValues />,
        },
        {
          parentId: "settings",
          id: "tags",
          icon: <Hash />,
          path: "/tags",
          title: "Tags",
          checkPermission: true,
          component: <Tags />,
        },
      ],
    },
  ];
}
